
export default {
  /*
   *
   * @example
   *
   * import utils from '@vue/utils/date.utils'
   * utils.hoursUntil(new Date('2025-07-29T16:00:00+01:00'));
   * 
  */

  hoursUntil: (date) => {
    return Math.floor((new Date(date) - new Date()) / (1000 * 60 * 60));
  }
}
